import type { AppRouteRecordRaw } from '@/router/types';

import { cloneDeep } from 'lodash-es';

import { routes, asyncRoutes } from '@/router/index';
import { UserApiSerivce } from '@/api/user';

export async function filterRouter() {
  return new Promise((resolve) => {
    UserApiSerivce.getMenuTree().then((result) => {
      const menuList = generateMenuByRouter(result[0].children, asyncRoutes);
      resolve([...menuList, routes]);
    });
  });
}

function generateMenuByRouter(menus: any, route: any): AppRouteRecordRaw[] {
  let idx = 0;
  const currentRouter = cloneDeep<any[]>(menus);
  for (let index = 0; index < menus.length; index++) {
    route &&
      route.forEach((routerItem: any) => {
        if (menus[index] && menus[index].code === routerItem.name) {
          const item: AppRouteRecordRaw = {
            component: routerItem.component || {},
            path: routerItem.path,
            name: routerItem.name,
            redirect: routerItem.redirect || '',
            meta: routerItem.meta,
            children: [],
          };

          if (menus[index].children) {
            item.children = generateMenuByRouter(
              menus[index].children,
              routerItem.children
            );
          }

          currentRouter[index - idx] = item;
        } else {
          if (!routerItem.meta.permissions) {
            if (
              !currentRouter.some((v) => {
                if (v.meta) {
                  return v.name === routerItem.name;
                } else {
                  return v.code === routerItem.name;
                }
              })
            ) {
              currentRouter.push(routerItem);
            }
          }
        }
      });

    //  当有从后台获取的菜单没有被覆盖时，干掉对应的菜单
    if (
      currentRouter[index - idx] &&
      currentRouter[index - idx].path === undefined
    ) {
      currentRouter.splice(index - idx, 1);
      idx = idx + 1;
    }
  }
  return currentRouter;
}

// export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList];

export const basicRoutes = [routes];
